import React from 'react';

import ContactSelector from 'bundles/backoffice/contacts/selector';
import { EmployerInput } from './employer_input';

import type { AddContactWorkflow } from './workflow';
import type { Contact } from 'bundles/backoffice/contacts/types';

interface Props {
  workflow: AddContactWorkflow;
  allowTagging?: boolean;
  showQuickbooks?: boolean;
}

export function AddContactInputs({ workflow, allowTagging, showQuickbooks }: Props) {
  const { contact, employer, visibility } = workflow;
  const requestPermissions = Boolean(visibility);

  let contactLabel: string;
  if (contact?.isBusiness) {
    contactLabel = 'Company';
  } else if (contact?.isPerson) {
    contactLabel = 'Person';
  } else {
    contactLabel = 'Person or company';
  }

  return <>
    <div className="form-group required">
      <label className="form-label">{contactLabel}</label>
      <ContactSelector
        allowTagging={allowTagging}
        contact={contact}
        modalBackdrop={false}
        newContactVisibility={visibility}
        requestPermissions={requestPermissions}
        showQuickbooks={showQuickbooks}
        onChange={(contact: Contact | null) => workflow.change({ contact, employer: contact?.business || null })}
      />
    </div>

    {contact?.isPerson &&
      <EmployerInput
        allowTagging={allowTagging}
        contact={contact}
        employer={employer}
        key={contact.id}
        newContactVisibility={visibility}
        requestPermissions={requestPermissions}
        onChange={employer => workflow.change({ employer })}
      />
    }
  </>;
}
